import { createAction, props } from '@ngrx/store';
import {
  IPaymentDataRequestBody,
  IPaymentDataResponse,
  IUpdateBillingPaymentRequestBody,
} from '@dch/billing-business-logic';

export const SAVE_PAYMENT_DATA_REQUEST = 'SAVE_PAYMENT_DATA_REQUEST';
export const SAVE_PAYMENT_DATA_SUCCESS = 'SAVE_PAYMENT_DATA_SUCCESS';
export const SAVE_PAYMENT_DATA_FAILURE = 'SAVE_PAYMENT_DATA_FAILURE';
export const RESET_PAYMENT_DATA = 'RESET_PAYMENT_DATA';

export const UPDATE_BILLING_PAYMENT_REQUEST = 'UPDATE_BILLING_PAYMENT_REQUEST';
export const UPDATE_BILLING_PAYMENT_SUCCESS = 'UPDATE_BILLING_PAYMENT_SUCCESS';
export const UPDATE_BILLING_PAYMENT_FAILURE = 'UPDATE_BILLING_PAYMENT_FAILURE';

export const savePaymentDataRequest = createAction(
  SAVE_PAYMENT_DATA_REQUEST,
  props<{
    billingAccountNumber: string;
    requestBody: IPaymentDataRequestBody;
  }>()
);
export const savePaymentDataSuccess = createAction(
  SAVE_PAYMENT_DATA_SUCCESS,
  props<{ response: IPaymentDataResponse }>()
);
export const savePaymentDataFailure = createAction(SAVE_PAYMENT_DATA_FAILURE);

export const resetPaymentData = createAction(RESET_PAYMENT_DATA);

export const updateBillingPaymentRequest = createAction(
  UPDATE_BILLING_PAYMENT_REQUEST,
  props<{
    billingAccountNumber: string;
    requestBody: IUpdateBillingPaymentRequestBody;
  }>()
);
export const updateBillingPaymentSuccess = createAction(
  UPDATE_BILLING_PAYMENT_SUCCESS,
  props<{ response: IPaymentDataResponse }>()
);
export const updateBillingPaymentFailure = createAction(
  UPDATE_BILLING_PAYMENT_FAILURE
);
